import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import { LinkinBioModule } from './app';
import { getPath } from './utils';
import { SENTRY_CONFIG, PACKAGE } from './constants';

Sentry.init({
  dsn: SENTRY_CONFIG.SENTRY_DSN,
  environment: PACKAGE.ENVIRONMENT,
  integrations: [new BrowserTracing()],
  tracesSampleRate: 1.0,
  release: `${PACKAGE.NAME}@${PACKAGE.VERSION}`,
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
const pageHandle = getPath(window.location.pathname);
root.render(
  <React.StrictMode>
    <div className="App">
      <LinkinBioModule pageHandle={pageHandle} />
    </div>
  </React.StrictMode>,
);
